import React, { Component } from "react";
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Select from "react-select";
import { USER_STUDIO_WALL, addApp, updateApp } from '../../../../../../../actions/sceneActions'
import './clock/clock.css'
import { customClass, getInitialRoute, stripTrailingSlash } from '../../../../../../../utils'
import {
    Card,
    Button,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import moment from 'moment';
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import ClockPreview from "../../../_metronic/_partials/apps/clock";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import UploadStudio from "../../Upload_Studio";
import { UPPY_BUCKET_URL } from "../../../../../../../actions/constant";


const TimeFormatOptions = [
    { value: 0, label: "12 Hrs" },
    { value: 1, label: "24 Hrs" },
];
let timeZonesListData = moment.tz.names();
let timeZonesList = []
timeZonesListData.map((item) => timeZonesList.push({ value: item, label: item }))

const backgroundFormatOptions = [
    { value: 0, label: "Background Color" },
    { value: 1, label: "Background Image" },
];
const layoutOptions = [
    { value: 0, label: "Classic" },
    { value: 1, label: "Digital" },
];
class ClockTimeDate extends Component {
    state = {
        updateApi: false,
        timeZoneValue: moment.tz.guess(),
        timeFormat: 0,
        timeLayout: 0,
        isSecond: true,
        isDate: true,
        isBackground: 0,
        Background: null,
        textColor: null,
        backgroundImage: "",
        selectedFile: null,
        selectedUrl: null,
        selectedName: null,
        updateApi: false,
        buttonDis:false,
        loader:false,
        stateChanged: false,
        upBg:null
    }
    componentDidMount() {
        const { scenes,location } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data && location.pathname.includes('update')) {
            const { timeZoneValue,
                timeFormat,
                timeLayout,
                isSecond,
                isDate, isBackground, Background, backgroundImage, textColor } = app_data;
            if (timeZoneValue) this.setState({
                timeZoneValue,
                timeFormat,
                timeLayout,
                isSecond,
                isDate, isBackground, Background, selectedUrl: backgroundImage, backgroundImage, textColor, updateApi: true
            });
        }
        else {
            this.setState({
                Background: "#ffffff",
                textColor: "#000000"
            })
        }
         
        this.setState({ Defaulttz: moment.tz.guess() })

        setTimeout(() => {
            window.$('#bgColor').minicolors({
              control: 'hue',
              defaultValue: this.validate_color(this.value) ? this.state.Background : '#fff',
              letterCase: 'lowercase',
              position: 'bottom left',
              change: this.bgChange,
              theme: 'bootstrap'
            });

            window.$('#textColor').minicolors({
                control: 'hue',
                defaultValue: this.validate_color(this.value) ? this.state.textColor : '#000',
                letterCase: 'lowercase',
                position: 'bottom left',
                change: this.colorChange,
                theme: 'bootstrap'
              });
          })
    }

    componentDidUpdate(preProps, nextProps) {
        if (preProps !== nextProps) {
            window.$('#bgColor').minicolors({
                control: 'hue',
                defaultValue: this.validate_color(this.value) ? this.state.Background : '#fff',
                letterCase: 'lowercase',
                position: 'bottom left',
                change: this.bgChange,
                theme: 'bootstrap'
              });
        };
      }
        
    validate_color = (c) => {
        var litmus = 'red';
        var d = document.createElement('div');
        d.style.color = litmus;
        d.style.color = c;
        if (c !== litmus && (d.style.color === litmus || d.style.color === '')) {
          return false;
        }
        return true;
      }


    bgChange = (value) => {
        this.setState({ Background: value, stateChanged:true })
    }
    
    colorChange = (value) => {
        this.setState({ textColor: value, stateChanged:true })
    }

    changeTimeFormatUpdate = (event) => {
        this.setState({ timeFormat: event.value, stateChanged:true });
    };
    changeLayoutUpdate = (event) => {
        this.setState({ timeLayout: event.value, stateChanged:true });

    };

    changelTimeZoneUpdate = (event) => {
        this.setState({ timeZoneValue: event.value, stateChanged:true });
    };

    removeBgImage = event => this.setState({
        backgroundImage: '', selectedUrl: '', selectedName: '', upBg : Math.random()
    })
  

    updateBackground = event => {
        this.setState({ backgroundImage: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedUrl: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedName: event.name, stateChanged:true })
    }



    onTimerSave = (event) => {
        const { param, scenes } = this.props;
        const { timeZoneValue,
            timeFormat,
            timeLayout,
            isSecond,
            isDate, isBackground, Background, backgroundImage, textColor } = this.state;
            const { app_data } = scenes.updateSceneData;
 
        if (timeZoneValue) {
            this.setState({loader:true, buttonDis:true})

            if(backgroundImage) this.resetUppy();
            
            this.state.updateApi
                ? this.props.updateApp(
                    param.contentMixId,
                    this.props.scenes.updateSceneData.id,
                    {
                        timeZoneValue,
                        timeFormat,
                        timeLayout,
                        isSecond,
                        isDate, isBackground, Background, backgroundImage: backgroundImage, textColor
                    },
                    3,
                    this.onSaveCallBack
                )
                : this.props.addApp(
                    param.contentMixId,
                    param.positionID,
                    {
                        timeZoneValue,
                        timeFormat,
                        timeLayout,
                        isSecond,
                        isDate, isBackground, Background, backgroundImage: backgroundImage, textColor
                    },
                    "Clock",
                    3,
                    this.onSaveCallBack
                );
        }
        else {
            Swal.fire({
                title: 'Error',
                text: 'Please check all select!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    };

    resetUppy=()=>{  
        const uppyTotal = window.$(".uppy-u-reset");  
        if(uppyTotal && (uppyTotal.length==1 || uppyTotal.length==2)){
            window.$(".uppy-u-reset").click();
        }
    }

    onBack = (event) => {
        const { params } = this.props.match;
        const { pathname } = this.props.location; 

        if (!this.state.stateChanged) {
            this.props.history(stripTrailingSlash(pathname,params))
            return;
          }
        
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass

        }).then((result) => {
            if (result.value) {
                this.onTimerSave()
            } else if (result.dismiss === "cancel") {
                this.props.history(stripTrailingSlash(pathname,params))
            }
        });
    };

    onSaveCallBack = () => {
        const { params } = this.props.match;
        this.props.USER_STUDIO_WALL(params.wallId);
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_APPS_SUCCESS_SAVE,
            type: "success",
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
        }).then((result) => {
            this.setState({loader:false, buttonDis:false})
            this.props.history(`/studio/${params.wallId}`);
        });
    };

    onUpdateStatusSecond = event => {
        const { isSecond } = this.state;
        this.setState({ isSecond: !isSecond, stateChanged:true });
    }
    onUpdateStatusDate = event => {
        const { isDate } = this.state;
        this.setState({ isDate: !isDate, stateChanged:true });
    }
    onUpdateColor = (color) => {
        this.setState({ colorUpdate: color.hex, Background: color.hex, stateChanged:true })
    }
    onTextUpdateColor = (color) => {
        this.setState({ colorUpdate: color.hex, textColor: color.hex, stateChanged:true })
    }
    changeBackgroundUpdate = (event) => {
        this.setState({ isBackground: event.value, stateChanged:true });
    };
    handleOpen = event => this.setState({
        uppyBackgroundOpen: true,
        stateChanged:true
    })
    handleClose = event => this.setState({
        uppyBackgroundOpen: false,
        stateChanged:true
    })
    render() {
        const { match, name } = this.props;
        const { timeZoneValue, timeLayout, upBg,timeFormat, isSecond, isDate, Defaulttz, isBackground, buttonDis, loader ,backgroundImage, updateApi } = this.state;
        const { pathname } = this.props.location;

        return (
            <>
              { !updateApi ?
                <NavigationHeader
                    name={name}
                    backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
                /> : null }
                <div className="container-fluid subheader_content">
                    <Card className="select_wall mb-3 rounded-0 border-0 cdtd_clock">
                        <Card.Body className="p-0">
                            <Row>
                                <Col lg={4} className="border-right-lg">
                                    <Card className="border-0 rounded-0">
                                        <Card.Body className="p-4 card_height">
                                            <Form>
                                                <Form.Group className="form-group" controlId="text-background">
                                                    <Form.Label>Select Time Zone</Form.Label>
                                                    {timeZonesList && timeZonesList.length > 0 && <Select
                                                        value={timeZonesList.find(option => option.value === timeZoneValue)}
                                                        onChange={this.changelTimeZoneUpdate}
                                                        options={timeZonesList}
                                                    />}
                                                </Form.Group>
                                                <Form.Group className="form-group" controlId="text-background">
                                                    <Form.Label>Layout</Form.Label>
                                                    <Select
                                                        value={layoutOptions.find(option => option.value === timeLayout)}
                                                        onChange={this.changeLayoutUpdate}
                                                        options={layoutOptions}
                                                    />
                                                </Form.Group>
                                                <Form.Group className="form-group" controlId="text-background">
                                                    <Form.Label>Time Format</Form.Label>
                                                    <Select
                                                        value={TimeFormatOptions.find(option => option.value === timeFormat)}
                                                        onChange={this.changeTimeFormatUpdate}
                                                        options={TimeFormatOptions}
                                                    />
                                                </Form.Group>
                                                <Form.Group controlId="text-background" className="form-group tbdt_switchButton">
                                                    <Form.Label>Second (Hide/Show)</Form.Label>
                                                    <Form.Check style={{ marginLeft: 5 }} checked={isSecond} onClick={this.onUpdateStatusSecond} label="" className="enable-studio" type="switch" id="toggle-date" />
                                                </Form.Group>
                                                <Form.Group controlId="text-background" className="tbdt_switchButton form-group">
                                                    <Form.Label>Date (Hide/Show)</Form.Label>
                                                    <Form.Check style={{ marginLeft: 5 }} checked={isDate} onClick={this.onUpdateStatusDate} label="" className="enable-studio" type="switch" id="toggle-second" />
                                                </Form.Group>
                                                <Row style={{ marginRight: 0 }}>
                                                    <Col xl>
                                                        <Form.Group className="form-group" controlId="text-background">
                                                            <Form.Label>Background</Form.Label>
                                                            <Select
                                                                value={backgroundFormatOptions.find(option => option.value === isBackground)}
                                                                onChange={this.changeBackgroundUpdate}
                                                                options={backgroundFormatOptions}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xl>
                                                        {isBackground == 0 && <Form.Group className="form-group" controlId="background-color">
                                                            <Form.Label>Background Color</Form.Label>
                                                            <div className="w-100 cdtd_clock_color">

                                                                <input className="form-control minicolors-input" maxlength="10" type="text" id="bgColor" defaultValue={this.state.Background} />
                                                            
                                                            </div>
                                                        </Form.Group>}
                                                        {isBackground == 1 && <Form.Group className="form-group" controlId="background-image">

                                                            <Form.Label>Background Image</Form.Label>

                                                            <div className="w-100 cdtd_clock_bg">
                                                                <UploadStudio picture={backgroundImage} pic={'bg'} key={upBg}  removeImage={this.removeBgImage} updateImage={this.updateBackground}  />
                                                            </div>
                                                        </Form.Group>}
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginRight: 0 }}>
                                                    <Col xl>
                                                        <Form.Group className="form-group" controlId="text-color">
                                                            <Form.Label>Text Color</Form.Label>
                                                            <div className="w-100 cdtd_clock_color">
                                                                  <input className="form-control minicolors-input" maxlength="10" type="text" id="textColor" defaultValue={this.state.textColor} />
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xl></Col>
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                        <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                            <button
                                                className="btn btn-outline-dark me-3 btn-min-w"
                                                onClick={this.onBack}
                                            >
                                                <span className="position-relative">Back</span>
                                       </button>
                                            <Button
                                                variant="primary"
                                                disabled={ buttonDis } 
                                                className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                                                onClick={this.onTimerSave}
                                                id="Studio_Clock_App_Users"
                                            >
                                                Save
                                       </Button>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                                <Col
                                    lg={8}
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    <Card className="border-0 card w-100">
                                        <Card.Body className="border-0">
                                            <div className="wall_view">
                                                <div className="wall_view_wrapper">
                                                    {timeZoneValue && <ClockPreview {...this.state} />}
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
            </>

        );
    }
}

const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall,
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {

        addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
            dispatch(
                addApp(contentMixId, position, appContent, appName, appId, callBack)
            ),
        updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
            dispatch(
                updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
            ),
        USER_STUDIO_WALL: (wallID) => dispatch(USER_STUDIO_WALL(wallID)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(ClockTimeDate);

